import Header from '/views/sections/header/header';
export * from '/views/sections/header/use-header';

export default Header;
